import {UmpireImage} from '../umpire-image';
import {UmpireMatch} from '../umpire-match';
import {UmpireClub} from '../umpire-club';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireOttEvent} from '../umpire-ott-event';
import {UmpireOttFormat} from '../umpire-ott-format';
import {UmpireImageOrientation} from '../umpire-image-orientation';
import {UmpirePageComponentSize} from '../umpire-page-component-size';

export type PageTemplateComponentsType =
  | HomePageTemplateComponent[]
  | TicketPageTemplateComponent[]
  | OttPageTemplateComponent[];

export interface UmpirePageTemplate {
  id: string;
  publishedAt: string;
  type: string;
  relationshipNames: string[];
  components: PageTemplateComponentsType;
}

export interface UmpirePageTemplateComponent {
  id: string;
  kind: UmpireComponentTypeEnum;
  index: number;
  relationshipNames: string[];
  type: string;
}

export interface TicketPageTemplateComponent extends UmpirePageTemplateComponent {
  external_url: string;
  name: string;
  club: Partial<UmpireClub>;
  additional_asset: UmpireImage;
  background_photo: UmpireImage;
}

export interface HomePageTemplateComponent extends UmpirePageTemplateComponent {
  match: UmpireMatch;
}

export interface OttPageTemplateComponent extends UmpirePageTemplateComponent {
  is_featured: boolean;
  image_orientation: UmpireImageOrientation;
  size: UmpirePageComponentSize;
  name: string;
  events?: Partial<UmpireOttEvent>[];
  formats?: Partial<UmpireOttFormat>[];
  format?: Partial<UmpireOttFormat>;
  playlist?: Partial<UmpireOttFormat>;
  itemsCropped?: boolean;
}
